import React from 'react';

const WIDTH = 1140;
const HEIGHT = 200;
// Source paths are drawn on a 570x210 canvas; scale them up to the viewBox.
const SCALE_X = 2;
const SCALE_Y = HEIGHT / 210;
const GRID_STEPS = [0.2, 0.4, 0.6, 0.8];

const HUMAN_PATH = 'M10,150 C40,148 60,160 90,140 S140,80 170,96 S220,60 250,70 S300,40 330,52 S380,62 410,50 S460,30 500,44 S540,38 560,40';
const SYNTHETIC_PATH = 'M10,170 L250,170 L252,84 L560,84';

// Animated "human vs synthetic" input trace for the Kestrel hero.
export const KestrelTrace = () => (
    <svg
        className='kestrel-trace'
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        preserveAspectRatio='none'
        aria-hidden='true'
    >
        <g className='kestrel-trace__grid'>
            {GRID_STEPS.map(step => (
                <line key={`y${step}`} x1={0} x2={WIDTH} y1={HEIGHT * step} y2={HEIGHT * step} />
            ))}
            {GRID_STEPS.map(step => (
                <line key={`x${step}`} y1={0} y2={HEIGHT} x1={WIDTH * step} x2={WIDTH * step} />
            ))}
        </g>
        <g transform={`scale(${SCALE_X} ${SCALE_Y})`}>
            <path className='kestrel-trace__line kestrel-trace__line--synthetic' d={SYNTHETIC_PATH} />
            <path className='kestrel-trace__line kestrel-trace__line--human' d={HUMAN_PATH} />
        </g>
        <rect className='kestrel-trace__scan' x={0} y={0} width={2} height={HEIGHT} />
    </svg>
);
